import { Group, Indicator, Text, ThemeIcon, Tooltip } from "@mantine/core";
import { useMemo } from "react";
import { useProfileStore } from "../../../../../../../stores/UserStore";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import {
  IconClick,
  IconEyeCheck,
  IconMessage,
  IconMessageCancel,
  IconMessageCheck,
  IconUserPlus,
} from "@tabler/icons-react";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";

const ScoreCell = ({ row }) => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const profile = useProfileStore((s) => s.profile);
  const defaultScore = useMemo(() => {
    if (profile?.prm_scoring) return profile.prm_scoring;
    return {
      link_click: 10,
      open: 10,
      answer: 10,
      positive_answer: 50,
      negative_answer: -10,
      invitation_accepted: 30,
    };
  }, [profile]);

  const icons = {
    link_click: <IconClick size={18} />,
    open: <IconEyeCheck size={18} />,
    answer: <IconMessage size={18} />,
    positive_answer: <IconMessageCheck size={18} />,
    negative_answer: <IconMessageCancel size={18} />,
    invitation_accepted: <IconUserPlus size={18} />,
  };

  return (
    <Group gap={"sm"}>
      {Object.keys(defaultScore)
        .filter((x) => x !== "link_click_specific_link")
        .map((key) => {
          let field = Object.keys(row).find((x) => x.includes(key));
          let count = row[field];
          let link_click_count = current.history.filter(
            (x) =>
              x.event === "link_click" && x.workflow_programmation_id === row.programmation_id
          )?.length;

          return (
            <Tooltip
              key={key}
              label={`${lang.prm.details.campaigns_table.scores_count[key]} : ${count}`}
            >
              <Indicator
                label={key === "link_click" ? link_click_count : count}
                disabled={!count}
                size={"xs"}
                offset={4}
                color="red"
              >
                <ThemeIcon
                  variant="light"
                  color={count > 0 ? "primary" : "gray"}
                  size={"md"}
                >
                  {icons[key]}
                </ThemeIcon>
              </Indicator>
            </Tooltip>
          );
        })}

      <Text>=</Text>
      <Text fw={600}>{row.score}</Text>
    </Group>
  );
};

export default ScoreCell;
